import React, { useState, useEffect } from "react";
import { HeroSection, CampusSelector, QuickLinks, SchoolGallery, AcademicsShowcase, TestimonialsSection } from "../components/home";
import { AnnouncementTicker } from "../components/home/AnnouncementTicker";
import { AnnouncementsSection, EventsSection, ResourcesSection } from "../components/sections";
import { apiCall } from "../lib/api";

export const HomePage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [announcementsRes, eventsRes] = await Promise.all([
          apiCall("GET", "/announcements"),
          apiCall("GET", "/events")
        ]);
        setAnnouncements(announcementsRes);
        setEvents(eventsRes);
      } catch (err) { console.error("Failed to fetch data:", err); }
    };
    fetchData();
  }, []);

  return (
    <main>
      <AnnouncementTicker />
      <HeroSection />
      <CampusSelector />
      <SchoolGallery />
      <AcademicsShowcase />
      <QuickLinks />
      <AnnouncementsSection announcements={announcements} />
      <TestimonialsSection />
      <EventsSection events={events} />
      <ResourcesSection />
    </main>
  );
};
